import PropTypes from "prop-types";
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Breadcrumbs,
} from "@mui/material";
import AccountPopover from "./AccountPopover";
import { ArrowBack, Menu } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationsPopover from "./NotificationsPopover";
import ToDoDrawer from "./ToDoDrawer";

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar, drawerWidth }) {
  const navigate = useNavigate();
  const location = useLocation();

  const APPBAR_MOBILE = 64;
  const APPBAR_DESKTOP = 50;

  const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: "none",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    backgroundColor: alpha(theme.palette.background.default, 0.72),
    [theme.breakpoints.up("lg")]: {
      width: `calc(100% - ${drawerWidth + 1}px)`,
    },
  }));

  const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up("lg")]: {
      minHeight: APPBAR_DESKTOP,
      padding: theme.spacing(0, 5),
    },
  }));

  return (
    <>
      <RootStyle>
        <ToolbarStyle>
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary", display: { lg: "none" } }}
          >
            <Menu />
          </IconButton>
          {location.pathname.includes("/impex/invoices/") && (
            <IconButton
              aria-label="delete"
              sx={{
                mr: 1,
                backgroundColor: "#FFFFFF",
              }}
              onClick={() => navigate("/impex/invoices")}
            >
              <ArrowBack fontSize="small" />
            </IconButton>
          )}
          <Breadcrumbs aria-label="breadcrumb">
            <Typography sx={{fontSize:"13px"}} color="text.primary">Impex</Typography>
            {location.pathname.includes("/impex/dashboard") && (
              <Typography sx={{fontSize:"13px"}} color="text.primary">Dashboard</Typography>
            )}
            {location.pathname.includes("/impex/purchase-orders") && (
              <Typography sx={{fontSize:"13px"}} color="text.primary">Purchase Orders</Typography>
            )}
            {location.pathname.includes("/impex/forecast-orders") && (
              <Typography sx={{fontSize:"13px"}} color="text.primary">Forecast Orders</Typography>
            )}
            {location.pathname.includes("/impex/good-received-note") && (
              <Typography sx={{fontSize:"13px"}} color="text.primary">Goods Received Note</Typography>
            )}
            {location.pathname.includes("/impex/quality-check") && (
              <Typography sx={{fontSize:"13px"}} color="text.primary">Quality Check</Typography>
            )}
            {location.pathname.includes("/impex/invoices") && (
              <Typography  sx={{fontSize:"13px"}} color="text.primary">Invoice</Typography>
            )}
            {location.pathname.includes("/impex/completed-orders") && (
              <Typography  sx={{fontSize:"13px"}} color="text.primary">Completed Orders</Typography>
            )}
            {location.pathname.includes("/impex/invoices/") && (
              <Typography sx={{fontSize:"13px"}} color="text.primary">Details</Typography>
            )}
          </Breadcrumbs>

          <Box sx={{ flexGrow: 1 }} />
          <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 0.5, sm: 1.5 }}
          >
            <NotificationsPopover />
            <ToDoDrawer />
            <AccountPopover />
          </Stack>
        </ToolbarStyle>
      </RootStyle>
    </>
  );
}
